import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b01f443b-34d5-4fc7-9e0b-ca007ef072d9/artifacts/tahd0sec_IMG_0935.jpeg";

export default function WelcomePage() {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center px-6 bg-white"
      data-testid="welcome-page"
    >
      {/* Logo */}
      <div className="mb-12 animate-fade-in">
        <img 
          src={LOGO_URL} 
          alt="Zakharov & Dann Golf Team" 
          className="w-48 h-auto"
          data-testid="welcome-logo"
        />
      </div>

      {/* Welcome Text */}
      <div className="text-center mb-12 animate-slide-up">
        <h1 className="font-heading text-4xl font-bold text-black mb-4">
          Добро пожаловать
        </h1>
        <p className="text-apple-text-secondary text-lg">
          Мессенджер для гольф-команды
        </p>
      </div>

      {/* Action Buttons */}
      <div className="w-full max-w-sm space-y-4 animate-slide-up" style={{ animationDelay: '0.1s' }}>
        <Button
          onClick={() => navigate("/role-selection")}
          className="w-full h-14 bg-golf-green hover:bg-golf-green-hover text-white rounded-full text-lg font-semibold shadow-sm transition-all active:scale-95"
          data-testid="register-btn"
        >
          Регистрация
        </Button>
        
        <Button
          onClick={() => navigate("/login")}
          variant="ghost"
          className="w-full h-14 text-golf-green hover:bg-apple-gray rounded-full text-lg font-medium"
          data-testid="login-btn"
        >
          Уже есть аккаунт? Войти
        </Button>
      </div>
    </div>
  );
}
